"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const QrCodeIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.795 3.545h.773a.25.25 0 01.25.25v.773a.25.25 0 01-.25.25h-.773a.25.25 0 01-.25-.25v-.773a.25.25 0 01.25-.25z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 1a.5.5 0 00-.5.5v5.364a.5.5 0 00.5.5h5.364a.5.5 0 00.5-.5V1.5a.5.5 0 00-.5-.5H1.5zm.773 1.773a.5.5 0 01.5-.5H5.59a.5.5 0 01.5.5V5.59a.5.5 0 01-.5.5H2.773a.5.5 0 01-.5-.5V2.773z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.136 8.636h1.546a.5.5 0 01.5.5v.273a.5.5 0 01-.5.5H9.136a.5.5 0 01-.5-.5v-.273a.5.5 0 01.5-.5zm.274 2.546h-.274a.5.5 0 00-.5.5V14.5a.5.5 0 00.5.5h.273a.5.5 0 00.5-.5v-2.818a.5.5 0 00-.5-.5zm2.272 2.545h.273a.5.5 0 01.5.5v.273a.5.5 0 01-.5.5h-.273a.5.5 0 01-.5-.5v-.273a.5.5 0 01.5-.5zm1.273-5.091a.5.5 0 00-.5.5v.273a.5.5 0 00.5.5h.772v1.273h-2.045a.5.5 0 00-.5.5v.273a.5.5 0 00.5.5h2.045V14.5a.5.5 0 00.5.5h.273a.5.5 0 00.5-.5V9.136a.5.5 0 00-.5-.5h-1.545zm-1.523-5.091h.773a.25.25 0 01.25.25v.773a.25.25 0 01-.25.25h-.773a.25.25 0 01-.25-.25v-.773a.25.25 0 01.25-.25z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.636 1.5a.5.5 0 01.5-.5H14.5a.5.5 0 01.5.5v5.364a.5.5 0 01-.5.5H9.136a.5.5 0 01-.5-.5V1.5zm1.773.773a.5.5 0 00-.5.5V5.59a.5.5 0 00.5.5h2.818a.5.5 0 00.5-.5V2.773a.5.5 0 00-.5-.5H10.41z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.568 11.182h-.773a.25.25 0 00-.25.25v.773c0 .138.112.25.25.25h.773a.25.25 0 00.25-.25v-.773a.25.25 0 00-.25-.25z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 8.636a.5.5 0 00-.5.5V14.5a.5.5 0 00.5.5h5.364a.5.5 0 00.5-.5V9.136a.5.5 0 00-.5-.5H1.5zm.773 1.773a.5.5 0 01.5-.5H5.59a.5.5 0 01.5.5v2.818a.5.5 0 01-.5.5H2.773a.5.5 0 01-.5-.5V10.41z",
    clipRule: "evenodd"
  })))
});
QrCodeIcon.displayName = 'QrCodeIcon';
var _default = exports.default = QrCodeIcon;